import { useContext } from "react";
import { SupervisorContext } from "../../contexts/admin/Supervisor.context";
import { SocketContext } from "../../contexts/global/SocketContext";
import { Modal } from "../../styles/modal";
import { StyledSupervisorPage } from "./style"
import { SupervisorHeader } from "./SupervisorHeader";
import { SupervisorMenu } from "./SupervisorMenu";
import { ChatProvider } from "../../contexts/user/ChatContext";
import { AttendancesContext } from "../../contexts/user/AttendancesContext";
import { QrPendingNotice } from "../../components/QrPendingNotice";
import { NUMEROS_WHATSAPP_MENU, NumerosWhatsapp } from "./NumerosWhatsapp";

export const SupervisorPage = () => {
    const { page, selectedMenu, handleSelection } = useContext(SupervisorContext);
    const { pendingQrCodes, dismissedQrNumbers, dismissQrNotice } = useContext(SocketContext);
    const { modalState } = useContext(SupervisorContext);

    const qrNoticeNumbers = pendingQrCodes
        .map((pending) => pending.number)
        .filter((number) => !dismissedQrNumbers.includes(number));
    const { modalState: attendanceModalState } = useContext(AttendancesContext);

    return (
        <StyledSupervisorPage>
            <ChatProvider>
                <SupervisorMenu />
                <main>
                    <SupervisorHeader />
                    {page}
                </main>
                {
                    qrNoticeNumbers.length > 0 && selectedMenu !== NUMEROS_WHATSAPP_MENU &&
                    <QrPendingNotice
                        numbers={qrNoticeNumbers}
                        onOpenPanel={() => handleSelection(NUMEROS_WHATSAPP_MENU, <NumerosWhatsapp />)}
                        onClose={() => dismissQrNotice(qrNoticeNumbers)}
                    />
                }
                {
                    modalState.value &&
                    <Modal>
                        {modalState.value}
                    </Modal>
                }
                {
                    attendanceModalState.value
                }
            </ChatProvider>
        </StyledSupervisorPage>
    );
};